export default {
  default: {
    container: "w-full",
    loading: "w-full p-4 text-text",
    error: "w-full p-4 text-error",
    empty: "w-full p-4 text-text_secondary",
  },
  admin: {
    container: "w-full",
    loading: "w-full p-4 text-admin_text",
    error: "w-full p-4 text-admin_error",
    empty: "w-full p-4 text-admin_text_secondary",
  },
  article: {
    container: "w-full max-w-[580px] md:max-w-[700px] lg:max-w-[860px] xl:max-w-[1035px] mx-auto text-text",
    loading: "w-full p-4 text-text",
    error: "w-full p-4 text-error",
    empty: "w-full p-4 text-text_secondary",
  },
}
